import { createAction } from '@ngrx/store';

export const appLoaded = createAction('[App] App loaded');
